export const en = {
    'mutation-warning':
        'The operation is taking longer than usual. Wait a while and then refresh the page to see changes.',
    'request-error': 'Refresh the page or try signing in later'
};
